var FirebasePlugin;

function log(msg, opts) {
  opts = opts || {};
  opts.logLevel = opts.logLevel || "log";
  console[opts.logLevel](msg);
  opts.msg = msg;
}

function logError(msg, error) {
  if (typeof error === 'object') {
    msg += ': ' + JSON.stringify(error);
  } else if (typeof error === 'string') {
    msg += ': ' + error;
  }
  log(msg, {
    logLevel: "error"
  });
}

// Init
function onDeviceReady() {
  FirebasePlugin = window.FirebasePlugin;
  log("deviceready");

  // Set global error handler to catch uncaught JS exceptions
  var appRootURL = window.location.href.replace("index.html", '');
  window.onerror = function (errorMsg, url, line, col, error) {
    var logMessage = errorMsg;

    var sendError = function () {
      FirebasePlugin.logError(logMessage, null, function () {
        log("Sent JS exception");
      }, function (error) {
        logError("Failed to send JS exception", error);
      });
    };

    logMessage += ': url=' + url.replace(appRootURL, '') + '; line=' + line + '; col=' + col;

    sendError();
  };


  //Register handlers
  FirebasePlugin.onMessageReceived(function (message) {
    try {
      console.log("onMessageReceived");
      console.dir(message);
      if (message.messageType === "notification") {
        handleNotificationMessage(message);
      } else {
        handleDataMessage(message);
      }
    } catch (e) {
      logError("Exception in onMessageReceived callback: " + e.message);
    }

  }, function (error) {
    logError("Failed receiving FirebasePlugin message", error);
  });

  FirebasePlugin.onTokenRefresh(function (token) {
    log("Token refreshed: " + token)
    window.localStorage.setItem('FCMToken', token);
  }, function (error) {
    logError("Failed to refresh token", error);
  });

  checkNotificationPermission(false); // Check permission then get token

  checkAutoInit();

  // Platform-specific
  document.body.classList.add(cordova.platformId);
  if (cordova.platformId === "android") {
    initAndroid();
  } else if (cordova.platformId === "ios") {
    initIos();
  }

  FirebasePlugin.setBadgeNumber(0);
}

document.addEventListener("deviceready", onDeviceReady, false);

var initIos = function () {
  FirebasePlugin.onApnsTokenReceived(function (token) {
    log("APNS token received: " + token)
  }, function (error) {
    logError("Failed to receive APNS token", error);
  });
};

var initAndroid = function () {
};

// Notifications
var checkNotificationPermission = function (requested) {
  FirebasePlugin.hasPermission(function (hasPermission) {
    if (hasPermission) {
      log("Remote notifications permission granted");
      // Granted
      getToken();
    } else if (!requested) {
      // Request permission
      log("Requesting remote notifications permission");
      FirebasePlugin.grantPermission(checkNotificationPermission.bind(this, true));
    } else {
      // Denied
      logError("Notifications won't be shown as permission is denied");
    }
  });
};

var checkAutoInit = function () {
  FirebasePlugin.isAutoInitEnabled(function (enabled) {
    log("Auto init is " + (enabled ? "enabled" : "disabled"));
    document.body.classList.add('autoinit-' + (enabled ? 'enabled' : 'disabled'));
    document.body.classList.remove('autoinit-' + (enabled ? 'enabled' : 'disabled'));
  }, function (error) {
    logError("Failed to check auto init", error);
  });
};

var getToken = function () {
  FirebasePlugin.getToken(function (token) {
    log("Got FCM token: " + token);
    window.localStorage.setItem('FCMToken', token);
  }, function (error) {
    logError("Failed to get FCM token", error);
  });
};


var handleNotificationMessage = function (message) {

  var title;
  if (message.title) {
    title = message.title;
  } else if (message.notification && message.notification.title) {
    title = message.notification.title;
  } else if (message.aps && message.aps.alert && message.aps.alert.title) {
    title = message.aps.alert.title;
  }

  var body;
  if (message.body) {
    body = message.body;
  } else if (message.notification && message.notification.body) {
    body = message.notification.body;
  } else if (message.aps && message.aps.alert && message.aps.alert.body) {
    body = message.aps.alert.body;
  }

  var msg = "Notification message received";
  if (message.tap) {
    msg += " (tapped in " + message.tap + ")";
  }
  if (title) {
    msg += '; title=' + title;
  }
  if (body) {
    msg += '; body=' + body;
  }
  msg += ": " + JSON.stringify(message);
  log(msg);
};

var handleDataMessage = function (message) {
  log("Data message received: " + JSON.stringify(message));
};